import { OAuthProvider, signInWithPopup, type Auth, type User } from 'firebase/auth';

export async function signInWithApplePopup(auth: Auth): Promise<User> {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  // Firebase owns the OAuth exchange. Never persist provider tokens or auto-link accounts.
  return (await signInWithPopup(auth, provider)).user;
}

export function formatAppleAuthError(error: unknown): string {
  const code =
    typeof error === 'object' && error !== null && 'code' in error ? String(error.code) : '';
  switch (code) {
    case 'auth/operation-not-allowed':
    case 'auth/invalid-oauth-client-id':
    case 'auth/unauthorized-domain':
      return 'Apple sign-in is not available yet. Please use Google or email for now.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
    case 'auth/user-cancelled':
      return 'Apple sign-in was cancelled. You can try again when you are ready.';
    case 'auth/popup-blocked':
      return 'Please allow pop-ups for this site, then try Apple sign-in again.';
    case 'auth/account-exists-with-different-credential':
      return 'Use your existing sign-in method to access this account. Accounts are not linked automatically.';
    case 'auth/network-request-failed':
      return 'Check your internet connection and try Apple sign-in again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    default:
      return 'Unable to sign in with Apple. Please try again or use another sign-in method.';
  }
}
